import { useMobileDetector } from "../../../../utils/customHooks";
import {
	Section,
	SectionHeading,
	TextRow,
	OpportunityWrapper,
	OpportunityContainer,
	ArrowIcon,
} from "./style";

import arrorRight from "../../../../Assets/Images/Home/arrow-right-dark.svg";

import careers from "../../../../Assets/Lang/en/careers/careers.json"

const OpportunitySection = () => {
	const ismobile = useMobileDetector();

	return (
		<Section>
			<SectionHeading>
				{ismobile ? (
					<>
						<TextRow>Opportunities</TextRow>
						<TextRow>waiting to</TextRow>
						<TextRow>be owned</TextRow>
					</>
				) : (
					<>
						<TextRow>Opportunities waiting to</TextRow>
						<TextRow>be owned</TextRow>
					</>
				)}
			</SectionHeading>
			<OpportunityWrapper>
				{Object.keys(careers).map((id) => (
					<OpportunityContainer to={id} key={id}>
						<span>{careers[id].shortTitle ?? careers[id].title}</span>
						<p>
							<span>{careers[id].positionOverview.join(' | ')}</span>
							<ArrowIcon src={arrorRight} />
						</p>
					</OpportunityContainer>
				))}
			</OpportunityWrapper>
		</Section>
	);
};

export default OpportunitySection;
